// extracted by mini-css-extract-plugin
module.exports = {"theme-hoem-page":"style_theme-hoem-page__Wj66t"};